import * as React from 'react';
import { useSelector } from 'react-redux';
import { Header2, Header3, UIText2 } from '@cian/ui-kit';
import { useDeviceCondition } from '../../../../hooks';
import { selectOfferAddress } from '../../../../selectors/offer';
import * as styles from './PublicationTitle.css';
import { useAppContext } from '../../../../../AppModulesWrapper';

export const PublicationTitle = () => {
  const Header = useDeviceCondition(Header2, Header3);
  const { isMicrofrontend } = useAppContext();
  const offerAddress = useSelector(selectOfferAddress);

  return (
    <div className={styles.root}>
      <Header data-testid="publication-title">Публикация объявления</Header>
      {!isMicrofrontend && Boolean(offerAddress) && (
        <div className={styles.subtitle}>
          <UIText2 color="gray60_100">{offerAddress}</UIText2>
        </div>
      )}
    </div>
  );
};
